import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { PageWrapper } from '../../components/UI';
import { UploadPoints, DownloadPointsAllocation } from './components';
import { ApplicationState } from '../../lib/Store';
import { DarkBlueHeaderL } from '../../Themes';
import { BulkUploadPointsResponse } from '../../lib/Api/Admin';

interface DownloadData extends BulkUploadPointsResponse {
  eventId: number;
  reward: any;
  companyId?: number;
}

const PointsAllocation: React.FC = () => {
  // State for download results
  const [downloadData, setDownloadData] = useState<DownloadData | null>(null);

  // Redux
  const { selectedEventId } = useSelector(
    ({ eventCompanyPageFilterState }: ApplicationState) => ({
      selectedEventId: eventCompanyPageFilterState.selectedEventId
    })
  );

  // Event handlers
  const handleCancelUpload = () => {
    setDownloadData(null);
  };

  const handleUploadSuccess = (data: DownloadData) => {
    setDownloadData(data);
  };

  // Render methods
  const renderNoEventMessage = () => (
    <DarkBlueHeaderL>Please select an event above</DarkBlueHeaderL>
  );

  const renderPageContent = () => {
    if (!selectedEventId) {
      return renderNoEventMessage();
    }
    
    if (downloadData) {
      return <DownloadPointsAllocation onCancel={handleCancelUpload} data={downloadData} />;
    }
    
    return <UploadPoints onCancel={handleCancelUpload} onSuccess={handleUploadSuccess} />;
  };

  return (
    <PageWrapper>
      {renderPageContent()}
    </PageWrapper>
  );
};

export default PointsAllocation; 